<template>
  <div class="flex flex-col">
    <MenuHeading @click="openSubMenu">{{ section.label }}</MenuHeading>
    <div
      :class="[
        'flex flex-col transition-all z-10',
        'lt-lg:fixed lt-lg:top-18 lt-lg:h-full lt-lg:overflow-y-auto lt-lg:bg-light lt-lg:w-full',
        { 'lt-lg:left-0': isSubMenuOpen },
        { 'lt-lg:left-full': !isSubMenuOpen },
      ]"
    >
      <button
        :class="[
          'font-secondary text-3xl',
          'lg:hidden',
          'lt-lg:flex lt-lg:items-center lt-lg:gap-3 lt-lg:py-4 lt-lg:px-5 lt-lg:bg-light-accent lt-lg:mb-6',
        ]"
        @click="closeSubMenu"
      >
        <Icon name="ChevronLeft" />{{ section.label }}
      </button>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import MenuHeading from '~/components/Header/MenuHeading.vue';

defineProps<{ section: object }>();
const isSubMenuOpen = ref(false);
const openSubMenu = () => {
  isSubMenuOpen.value = true;
};
const closeSubMenu = () => {
  isSubMenuOpen.value = false;
};
</script>

<style scoped></style>
